import { ShoppingBag } from 'lucide-react'
import type { ModuleDefinition } from '../types'
import { lazyPage } from '@/lib/lazyPage'

const StorefrontPage = lazyPage(() => import('@/pages/Storefront'), 'StorefrontPage')

export const storefrontModule: ModuleDefinition = {
  key: 'storefront',
  icon: ShoppingBag,
  iconName: 'shopping-bag',
  ready: true,
  ListPage: StorefrontPage,
  /* What the store shows is picked by the team in its own settings. */
  posting: false
}
